import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  CPTypesContent,
} from '../../components';

import css from './CPTypesPage.module.css';

const CPTypesPage = () => {
  // prettier-ignore
  return (
    <StaticPage
      title="Types of Communication Professionals for Deaf People"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description:
          'Find out about the different communication professionals for Deaf people and the regulatory bodies that monitor them',
        name: 'Types of Communication Professionals for Deaf People',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Types of Communication Professionals for Deaf People</h1>

          <CPTypesContent />
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default CPTypesPage;
